var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pub-container home"
  }, [_c("FormBox", {
    attrs: {
      title: "远程康复"
    },
    on: {
      inspect: _vm.inspectBtn
    }
  }, [_c("el-form", {
    ref: "form",
    staticStyle: {
      width: "100%",
      "padding-right": "20px"
    },
    attrs: {
      model: _vm.data,
      "label-width": "100px",
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "上传病例",
      prop: "medicalRecordFile"
    }
  }, [_c("van-uploader", {
    attrs: {
      "after-read": _vm.afterReadAvatar
    },
    on: {
      delete: _vm.scblBeforeDelete
    },
    model: {
      value: _vm.data.medicalRecordFile,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "medicalRecordFile", $$v);
      },
      expression: "data.medicalRecordFile"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "预约时间",
      prop: "appointmentTime"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请选择预约时间",
      readonly: ""
    },
    nativeOn: {
      click: function click($event) {
        _vm.showPicker = true;
      }
    },
    model: {
      value: _vm.data.appointmentTime,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "appointmentTime", $$v);
      },
      expression: "data.appointmentTime"
    }
  })], 1), _c("van-popup", {
    attrs: {
      position: "bottom"
    },
    model: {
      value: _vm.showPicker,
      callback: function callback($$v) {
        _vm.showPicker = $$v;
      },
      expression: "showPicker"
    }
  }, [_c("van-datetime-picker", {
    attrs: {
      type: "datetime",
      "min-date": _vm.minDate
    },
    on: {
      confirm: _vm.onConfirm,
      cancel: function cancel($event) {
        _vm.showPicker = false;
      }
    }
  })], 1), _c("div", {
    staticStyle: {
      margin: "16px",
      width: "100%",
      padding: "0 20px"
    }
  }, [_c("el-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary",
      round: "",
      disabled: _vm.isIpt
    },
    on: {
      click: function click($event) {
        return _vm.onSubmit("form");
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };